import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=e3378f50&"
import script from "./AdminSidebar.vue?vue&type=script&lang=ts&"
export * from "./AdminSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSidebar.vue?vue&type=style&index=0&id=e3378f50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports